import React, { useEffect } from 'react';
import { useParams, useHistory, generatePath } from 'react-router-dom';
// import validator from 'validator';
import { createState, useState, Downgraded } from '@hookstate/core';
import { isEmpty } from 'lodash-es';
import {
    Box,
    TextField,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Typography,
    Divider,
    CircularProgress,
    Button,
    Grid,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import stores
import { useEventState, updateModuleState } from '../../stores/eventStore';
// import utility and constants
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import AppConstants from '../../constants/appConstants';
import RouteConstants from '../../constants/routeConstants';
import { FULL_PERMISSION } from '../../constants/Constant';

import {
    // HotelNameList,
    HotelNeeded,
    // RoomAndTax,
    // RoomType,
} from '../../constants/Constant';
// import icons
import IconPencil from '../../assets/images/Icon_Pencil.svg';
import trash from '../../assets/images/trash.svg';
// import shared components
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import Title from '../../sharedcomponents/title/title';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
// import local components
import AddGuest from './addGuest';
import AddOccupant from './addOccupant';
import { useAgentState } from '../../hookState/AgentState';
import { MODULE_LIST } from '../../constants/Constant';
import AddCreditCard from '../AllStarTickets/ticket/addCreditCard';
import MUIDatePicker from '../../sharedcomponents/datePicker';
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';

const hotelState = createState({
    firstName: '',
    lastName: '',
    isDisable: false,
    hotelNameList: [],
    hotelID: 1,
    hotelNeededId: 1,
    hotelNeeded: HotelNeeded,
    // checkInDate: new Date(),
    // checkOutDate: new Date(),
    checkInDate: null,
    checkOutDate: null,
    occupant: '',
    specialRequest: '',
    roomAndTax: [],
    roomAndTaxID: 1,
    roomTypeID: 1,
    roomType: [],
    guests: [],
    occupantList: [],
    addedFor: '',
});
const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});

const CreateDraftHotel = (props) => {
    const classes = useStyles();
    const eventState = useEventState();
    const state = useState(hotelState);
    const agentState = useAgentState();
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    // const [autoApprove, setAutoApprove] = React.useState(0);
    const eventModuleConfigInfo = Helper.getStorage('eventModuleConfig') ?? [];
    // console.log('eventModuleConfigInfo', eventModuleConfigInfo);
    const [eventConfig, setEventConfig] = React.useState({
        paid: 0,
        comp: 0,
    });
    const [roomState, setRoomState] = React.useState({
        compCount: 0,
        paidCount: 0,
    });
    const [isAdmin, setIsAdmin] = React.useState(false);
    const hotelEventConfig =
        eventModuleConfigInfo &&
        eventModuleConfigInfo.filter(
            (key) =>
                key.moduleName.toLowerCase() ===
                MODULE_LIST[7].toLocaleLowerCase()
        );
    var hotelKeyValue =
        hotelEventConfig &&
        hotelEventConfig.reduce(
            (obj, item) => Object.assign(obj, { [item.key]: item.description }),
            {}
        );
    const [checkInFromDate, setCheckInFromDate] = React.useState('');
    const [checkInToDate, setCheckInToDate] = React.useState('');

    const [checkOutFromDate, setCheckOutFromDate] = React.useState('');
    const [checkOutToDate, setCheckOutToDate] = React.useState('');
    const disabledcheckinDates = useState([]);
    const disabledcheckoutDates = useState([]);
    //console.log(hotelKeyValue.RoomNeeded);
    //console.log(!isEmpty(hotelKeyValue));

    const [hotelNameList] = React.useState([]);
    const [hotelRoomType, setHotelRoomType] = React.useState([]);
    const [hotelRoomTax, setHotelRoomTax] = React.useState([]);
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [disableDate, setDisableDate] = React.useState(false);
    const [showSaveAsDraftBtn, setShowSaveAsDraftBtn] = React.useState(false);

    const loading = useState(false);
    let params = useParams();
    const history = useHistory();
    const [hotelBookingID, setHotelBookingID] = React.useState(0);
    const [participantList, setParticipantList] = React.useState(null);
    const [eventParticipantList, setEventParticipantList] = React.useState(null);
    const [participant, setParticipant] = React.useState(null);

    const [firstNameErr, setFirstNameErr] = React.useState('');
    const [lastNameErr, setLastNameErr] = React.useState('');

    // const [occupantErr, setOccupantErr] = React.useState('');
    const [guestCounter, setGuestCounter] = React.useState(1);
    const openDialog = useState(false);
    const openOccupantDialog = useState(false);
    const stateObj = useState(null);
    const stateOccupantObj = useState(null);

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    const [roomTaxID, setRoomTaxID] = React.useState(0);
    const [showLoading, setShowLoading] = React.useState(false);
    const [hotelCompCount, setHotelCompCount] = React.useState(0);
    const [hotelPurchaseCount, setHotelPurchaseCount] = React.useState(0);
    const [hotelCompAllotmentCount, setHotelCompAllotmentCount] =
        React.useState(0);
    const [hotelPurchaseAllotmentCount, setHotelPurchaseAllotmentCount] =
        React.useState(0);

    const [showCreditCard, setShowCreditCard] = React.useState(false);
    const [prevCreditCards, setPrevCreditCards] = React.useState([]);
    const [selectedCard, setSelectedCard] = React.useState(null);
    const [userID, setUserID] = React.useState(0);
    const [eventID, setEventID] = React.useState(0);
    const logoURL = process.env.REACT_APP_CREDIT_LOGOS;
    const [showCardValidationMessage, setShowCardValidationMessage] = React.useState(false);
    const [dirty, setDirty] = React.useState(false);
    const [openBackdrop, setOpenBackDrop] = React.useState(false);
    const [copyOfState, setCopyOfState] = React.useState(null);
    const [isAgentRequestAccepted, setIsAgentRequestAccepted] = React.useState(undefined);
    const [showAgentRequestConfirmDialog, setShowAgentRequestConfirmDialog] = React.useState(false);

    useEffect(() => {
        // fetchHotelList(); 
        setEventID(eventInfo.evenID);
        setUserID(userInfo.userID);
        fetchEventDefaultConfig(eventInfo.eventID);
        fetchHotelRoomTax();
        fetchHotelRoomType();
        if (history.location.state.roomState) {
            let rState = history.location.state.roomState;
            setRoomState({
                ...roomState,
                compCount: rState.compCount,
                paidCount: rState.paidCount,
            });
            getAllotmentCount(userInfo);

            // if (!Helper.isAdminUser(userInfo) && !Helper.isEventAdmin(userInfo) && !Helper.isEventStaff(userInfo)) {
            //     fetchAgentRoomRequest(userInfo);
            // }
        }

        //getEventConfig();
        return () => {
            resetState();
        }
    }, []);

    useEffect(() => {
        if (history.location.state.admin) {
            setIsAdmin(history.location.state.admin);
        }
        else if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            setIsAdmin(true);
        }

    }, [userInfo])

    // useEffect(() => {
    //     if (!Helper.isAdminUser(userInfo) && !Helper.isEventAdmin(userInfo) && !Helper.isEventStaff(userInfo)
    //         && (isAgentRequestAccepted === null || isAgentRequestAccepted === '') && hotelPurchaseCount > 0) {
    //         setShowAgentRequestConfirmDialog(true);
    //     }

    // }, [isAgentRequestAccepted, hotelPurchaseCount])

    useEffect(() => {
        if (eventState.get() && eventState.eventDetail.get() != null) {
            if (!Helper.isAdminUser(userInfo) && !Helper.isEventAdmin(userInfo)) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'DRAFTHOTEL')
                    );
                }
            } else if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);

    useEffect(() => {
        // console.log('modPermission', modPermission);
        if (modPermission && modPermission == FULL_PERMISSION) {
            if (params.hotelBookingID) {
                if (history.location.state.hotelState) {
                    const editHotelState = history.location.state.hotelState;
                    // debugger // eslint-disable-line no-debugger
                    // set the existing state for event
                    GetAdminEventParticipant(
                        eventInfo,
                        userInfo,
                        editHotelState.addedFor
                    );
                    setHotelBookingID(params.hotelBookingID);
                    setRoomTaxID(editHotelState.hotelRoomTaxID);
                    if ((agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(agentInfo) || Helper.isAdminUser(agentInfo) || Helper.isEventStaff(agentInfo))) {
                        getTagIDByUserID(eventInfo.eventID, agentInfo.userID)
                    } else if (!(agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))) {
                        getTagIDByUserID(eventInfo.eventID, userInfo.userID)
                    }
                    state.set({
                        firstName: editHotelState.firstName,
                        lastName: editHotelState.lastName,
                        isDisable: false,
                        hotelNameList: hotelNameList,
                        hotelID: editHotelState.hotelID,
                        hotelNeededId: editHotelState.roomNeeded ? 1 : 0,
                        hotelNeeded: HotelNeeded,
                        checkInDate: editHotelState.checkIn ? new Date(editHotelState.checkIn) : null,
                        checkOutDate: editHotelState.checkOut ? new Date(editHotelState.checkOut) : null,
                        occupant: editHotelState.occupant,
                        specialRequest: editHotelState.specialRequest,
                        roomAndTax: hotelRoomTax,
                        roomAndTaxID: editHotelState.hotelRoomTaxID,
                        roomTypeID: editHotelState.hotelRoomTypeId,
                        roomType: hotelRoomType,
                        guests: editHotelState.guestList
                            ? editHotelState.guestList
                            : [],
                        occupantList: editHotelState.occupantList
                            ? editHotelState.occupantList
                            : [],
                        addedFor: editHotelState.addedFor
                            ? editHotelState.addedFor
                            : '',
                    });
                    if (
                        editHotelState.creditCardID &&
                        editHotelState.summary &&
                        editHotelState.brand &&
                        editHotelState.cardName
                    ) {
                        setSelectedCard({
                            creditCardID: editHotelState.creditCardID,
                            summary: editHotelState.summary,
                            token: '',
                            reference: '',
                            brand: editHotelState.brand,
                            cardName: editHotelState.cardName,
                            email: editHotelState.email,
                        });
                    }
                }
            } else {
                if ((agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(agentInfo) || Helper.isAdminUser(agentInfo) || Helper.isEventStaff(agentInfo))) {
                    getTagIDByUserID(eventInfo.eventID, agentInfo.userID)
                } else if (!(agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))) {
                    getTagIDByUserID(eventInfo.eventID, userInfo.userID)
                }
                resetState();
                GetAdminEventParticipant(
                    eventInfo,
                    userInfo,
                    userInfo.userID
                );
            }
        }
    }, [params.hotelBookingID, modPermission]);

    useEffect(() => {
        if (hotelRoomType && hotelRoomType.length > 0 && hotelRoomTax && hotelRoomTax.length > 0) {
            let roomTaxID = 1;
            let roomTax = [...hotelRoomTax];
            // if (!isAdmin && (isAgentRequestAccepted != null && isAgentRequestAccepted !== '' && isAgentRequestAccepted == false) || !hotelPurchaseCount || hotelPurchaseCount === 0) {
            //     roomTax = roomTax.filter(i => i.value !== 2);
            // }

            if (!isAdmin) {
                //remove comp option from dropdown if allotment is 0
                if (!hotelCompCount || hotelCompCount === 0) {
                    roomTax = roomTax.filter(i => i.value !== 1);
                    roomTaxID = 2;
                }
                //remove purchase option from dropdown if allotment is 0
                if ((!hotelPurchaseCount || hotelPurchaseCount === 0)) {
                    roomTax = roomTax.filter(i => i.value !== 2);

                    if (roomTax && !roomTax.some(i => i.value !== 1)) {
                        roomTaxID = 3;
                    }
                }
            }

            state.set({
                ...state.get(),
                roomAndTaxID: params.hotelBookingID > 0 ? state.roomAndTaxID.get() : roomTaxID,
                roomType: hotelRoomType,
                roomAndTax: roomTax
            });

        }
    }, [hotelRoomType, hotelRoomTax, hotelCompCount, hotelPurchaseCount, participant, isAgentRequestAccepted]);

    const fetchAgentRoomRequest = (item) => {
        ApiHelper.get(
            APIURLConstants.GET_AGENT_ROOM_REQUEST_BY_USERID(
                eventInfo.eventID,
                22,
                item.userID
            )
        ).then((res) => {
            setIsAgentRequestAccepted(res.data);

        }).catch((err) => {
            console.log('error while getting agent Room request', err)
        });
    }

    const handleClose = () => {
        openDialog.set(false);
    };
    const handleOccupantClose = () => {
        openOccupantDialog.set(false);
        handleDisableBtn();
    };
    const handleOccupantAction = (fName, lName, i) => {
        const values = [...hotelState.attach(Downgraded).get().occupantList];

        if (i >= 0) {
            values[i].firstName = fName;
            values[i].lastName = lName;
            state.occupantList.set(values);
        } else {
            values.push({
                firstName: fName,
                lastName: lName,
            });

            state.occupantList.set(values);
        }
        openOccupantDialog.set(false);
        handleDisableBtn();
        setDisableBtn(false)
    };

    const handleOccupantCounter = () => {
        setGuestCounter(guestCounter + 1);
        if (state.occupantList.get() && state.occupantList.get().length >= 5) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message:
                    'Max Occupant ' + state.occupantList.get().length + ' only',
            });
            return;
        }
        openOccupantDialog.set(true);
        stateOccupantObj.set(null);
    };

    const handleOccupantEditData = (firstName, lastName, relation, id) => {
        openOccupantDialog.set(true);
        stateOccupantObj.set({
            firstName: firstName,
            lastName: lastName,
            id: id,
        });
    };

    const handleAction = (
        fName,
        lName,
        rTypeId,
        rTaxId,
        inDate,
        outDate,
        rTypeName,
        rTaxName,
        i
    ) => {
        const values = [...hotelState.attach(Downgraded).get().guests];

        if (i >= 0) {
            values[i].guestFirstName = fName;
            values[i].guestLastName = lName;
            values[i].roomTypeID = rTypeId;
            values[i].roomAndTaxID = rTaxId;
            values[i].guestCheckIn = `${Helper.FormatYearDate(
                inDate
            )}T${Helper.FormatTime24(inDate)}`;
            values[i].guestCheckOut = `${Helper.FormatYearDate(
                outDate
            )}T${Helper.FormatTime24(outDate)}`;
            values[i].roomType = rTypeName;
            values[i].roomAndTax = rTaxName;

            state.guests.set(values);
        } else {
            values.push({
                guestFirstName: fName,
                guestLastName: lName,
                roomTypeID: rTypeId,
                roomAndTaxID: rTaxId,
                guestCheckIn: `${Helper.FormatYearDate(
                    inDate
                )}T${Helper.FormatTime24(inDate)}`,
                guestCheckOut: `${Helper.FormatYearDate(
                    outDate
                )}T${Helper.FormatTime24(outDate)}`,
                roomType: rTypeName,
                roomAndTax: rTaxName,
            });

            state.guests.set(values);
        }
        openDialog.set(false);
    };

    const handleGuestCounter = () => {
        // setGuestCounter(guestCounter + 1);
        openDialog.set(true);
        stateObj.set(null);
        // console.log(counter);
    };

    const handleEditData = (
        firstName,
        lastName,
        checkInDate,
        checkOutDate,
        roomTypeID,
        roomAndTaxID,
        roomTypeName,
        roomTaxName,
        id
    ) => {
        openDialog.set(true);
        stateObj.set({
            firstName: firstName,
            lastName: lastName,
            checkInDate: checkInDate,
            checkOutDate: checkOutDate,
            roomTypeID: roomTypeID,
            roomAndTaxID: roomAndTaxID,
            roomTypeName: roomTypeName,
            roomTaxName: roomTaxName,
            id: id,
        });
    };

    const handleCheckInDateTime = (event) => {
        state.checkInDate.set(dayjs(event).format('YYYY-MM-DDTHH:mm'));
        handleDisableBtn();
    };
    const handleCheckOutDateTime = (event) => {
        state.checkOutDate.set(dayjs(event).format('YYYY-MM-DDTHH:mm'));
        handleDisableBtn();
    };

    const handleChangeRoomType = (event) => {
        state.roomTypeID.set(event.target.value);
        handleDisableBtn();
    };

    const handleChangeRoomTax = (event) => {
        state.checkInDate.set('')
        state.checkOutDate.set('')
        state.roomAndTaxID.set(event.target.value);
        if (!isAdmin) {
            if ((agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(agentInfo) || Helper.isAdminUser(agentInfo) || Helper.isEventStaff(agentInfo))) {
                getTagIDByUserID(eventInfo.eventID, agentInfo.userID)
            } else if (!(agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))) {
                getTagIDByUserID(eventInfo.eventID, userInfo.userID)
            }
        }

        handleDisableBtn()
        // getEventConfig()
        // console.log(state);
        // if (admin === false) {
        //     if (event.target.value === 1) {
        //         state.checkInDate.set(
        //             new Date(
        //                 hotelKeyValue.ComplemintaryCheckin
        //                     ? hotelKeyValue.ComplemintaryCheckin
        //                     : ''
        //             )
        //         );
        //         state.checkOutDate.set(
        //             new Date(
        //                 hotelKeyValue.ComplimentaryCheckOut
        //                     ? hotelKeyValue.ComplimentaryCheckOut
        //                     : ''
        //             )
        //         );
        //     } else {
        //         state.checkInDate.set(
        //             new Date(
        //                 hotelKeyValue.ForPurchaseCheckin
        //                     ? hotelKeyValue.ForPurchaseCheckin
        //                     : ''
        //             )
        //         );
        //         state.checkOutDate.set(
        //             new Date(
        //                 hotelKeyValue.ForPurchaseCheckout
        //                     ? hotelKeyValue.ForPurchaseCheckout
        //                     : ''
        //             )
        //         );
        //     }
        // }
    };

    const handleRemove = (i) => {
        // setGuestCounter(guestCounter - 1);
        const values = [...hotelState.attach(Downgraded).get().guests];
        values.splice(i, 1);
        state.guests.set(values);
    };
    const handleRemoveOccupant = (i) => {
        // setGuestCounter(guestCounter - 1);
        const values = [...hotelState.attach(Downgraded).get().occupantList];
        values.splice(i, 1);
        state.occupantList.set(values);
        handleDisableBtn();
    };

    // const handleChangeHotel = (event) => {
    //     state.hotelID.set(event.target.value);
    // };

    const handleChangeHotelNeeded = (event) => {
        state.hotelNeededId.set(event.target.value);
        //setPassenger(event.target.value);
    };

    const handleBtnCancel = () => {
        props.history.goBack();
    };
    const GetAdminEventParticipant = async (gEventInfo, gUserInfo, userId) => {
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) ||
            (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
        ) {
            await ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );

                    setParticipantList(history.location.state.participantList);

                    const index = participants.findIndex(
                        (user) => user.userID == userId
                    );


                    if (index > -1) {
                        if (res.data.rows) {
                            // const userid = participants[index].userID;
                            // ApiHelper.get(
                            //     APIURLConstants.GET_TAGID_BY_USERID(gEventInfo.eventID, userid)
                            // ).then((res) => {
                            //     console.log(res);
                            //     if (res.data) {
                            //         let data = res.data;
                            //         let Tagsid = data[0].tagID.split(',');
                            //         if (data[0].tagID) {
                            //             getEventConfig(Tagsid)
                            //         }
                            //     }
                            // })
                        }
                        getAllotmentCount(participants[index]);
                        fetchAgentRoomRequest(participants[index]);
                        setParticipant(participants[index]);
                    }
                }
            });
        }
    };
    // const fetchHotelList = () => {
    //     ApiHelper.get(APIURLConstants.GET_HOTEL_LIST).then((res) => {
    //         if (res.data) {
    //             setHotelNameList(res.data);
    //         }
    //     });
    // };
    const fetchEventDefaultConfig = (eventID) => {
        const gAgentInfo = Helper.getStorage('agentUser');
        const agentConnection = Helper.getStorage('agentConnections');
        ApiHelper.get(
            APIURLConstants.GET_EVENT_DEFAULTS(
                eventID,
                0,
                agentConnection && gAgentInfo
                    ? gAgentInfo.userID
                    : userInfo.userID
            )
        ).then((res) => {
            // console.log(res);
            setEventConfig({
                ...eventConfig,
                paid: res.data.hotelPaid,
                comp: res.data.hotelComp,
            });
        });
    };
    const fetchHotelRoomTax = () => {
        ApiHelper.get(APIURLConstants.GET_HOTEL_ROOM_TAX).then((res) => {
            if (res.data) {
                setHotelRoomTax(res.data);
            }
        });
    };
    const fetchHotelRoomType = () => {
        ApiHelper.get(APIURLConstants.GET_HOTEL_ROOM_TYPE).then((res) => {
            if (res.data) {
                setHotelRoomType(res.data);
            }
        });
    };

    const getAllotmentCount = (item) => {
        // console.log(item, hotelCompAllotmentCount);
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        ApiHelper.get(
            APIURLConstants.GET_DRAFT_HOTEL_SETTING_BY_USERID(
                eventInfo.eventID,
                (Helper.isAdminUser(gAgentInfo) || Helper.isEventAdmin(gAgentInfo)) ? item.userID : agentConnection && gAgentInfo ? gAgentInfo.userID : item.userID
            )
        ).then((res) => {
            if (res.data) {
                const parseData = JSON.parse(res.data.setting);
                if (
                    parseData !== undefined &&
                    parseData.length > 0 &&
                    parseData[0].HotelSetting
                ) {
                    const settingParseData = JSON.parse(
                        parseData[0].HotelSetting
                    );

                    let purchaseCount = settingParseData && settingParseData.pay ? settingParseData.pay : 0;
                    let compCount = settingParseData && settingParseData.comp ? settingParseData.comp : 0;
                    setHotelPurchaseCount(Number(purchaseCount));
                    setHotelCompCount(Number(compCount));

                    setHotelPurchaseAllotmentCount(
                        Number(purchaseCount) - res.data.actualPayCount
                    );
                    setHotelCompAllotmentCount(
                        Number(compCount) - res.data.actualCompCount
                    );
                }
                else {
                    setHotelPurchaseCount(0);
                    setHotelCompCount(0);
                    setHotelPurchaseAllotmentCount(0);
                    setHotelCompAllotmentCount(0);
                }
            }
        });
    };

    const getEventConfig = async (id) => {
        //    ApiHelper.get(
        //         APIURLConstants.GET_EVENT_CONFIG(gEventInfo.eventID)
        //     ).then((res) => {
        //         // console.log("res", res);
        //         if (res.data && res.data.length > 0) {
        //             res.data.map((item) => {
        //                 if (item.moduleID === 22) {
        //                     if (state.roomAndTaxID.get() === 1) {
        //                         if (item.key === 'ComplemintaryCheckin') {
        //                             let explodeDate = item.description.split(',');
        //                             setCheckInFromDate(explodeDate[0]);
        //                             setCheckInToDate(explodeDate.slice(-1)[0]);
        //                         }
        //                         if (item.key === 'ComplimentaryCheckOut') {
        //                             let explodeDate = item.description.split(',');
        //                             setCheckOutFromDate(explodeDate[0]);
        //                             setCheckOutToDate(explodeDate.slice(-1)[0]);
        //                         }
        //                     }
        //                     if (state.roomAndTaxID.get() === 2) {
        //                         if (item.key === 'ForPurchaseCheckin') {
        //                             let explodeDate = item.description.split(',');
        //                             setCheckInFromDate(explodeDate[0]);
        //                             setCheckInToDate(explodeDate.slice(-1)[0]);
        //                         }
        //                         if (item.key === 'ForPurchaseCheckout') {
        //                             let explodeDate = item.description.split(',');
        //                             setCheckOutFromDate(explodeDate[0]);
        //                             setCheckOutToDate(explodeDate.slice(-1)[0]);
        //                         }
        //                     }

        //                 }
        //             });
        //         }
        //     });

        const eventID = eventInfo.eventID
        const moduleID = 7;
        const tagID = id

        await ApiHelper.get(
            APIURLConstants.GET_EVENT_TAG_DATES(eventID, moduleID, tagID)
        ).then((res) => {
            if (res.data.length > 0) {
                const data = res.data;
                let minDates = [];
                let maxDates = [];
                let fromDate = [];
                let toDate = [];
                setDisableDate(false)
                //console.log(data, state.roomAndTaxID.get());
                data.forEach((item) => {
                    if (state.roomAndTaxID.get() === item.isPurchase || (state.roomAndTaxID.get() === 3 && item.isPurchase && parseInt(item.isPurchase) === 2)) {
                        const types = item.type === 1 ? 'Fixed' : 'Range';
                        if (types === 'Range') {
                            const fromDate = item.fromDate;
                            const toDate = item.toDate;

                            minDates.push(fromDate);
                            maxDates.push(toDate);
                            setCheckInFromDate(minDates[0]);
                            setCheckInToDate(maxDates[0]);
                            setCheckOutFromDate(minDates[0]);
                            setCheckOutToDate(maxDates[0]);
                            disabledcheckinDates.set([]);
                            disabledcheckoutDates.set([]);
                        } else if (types === 'Fixed') {
                            setCheckInFromDate('');
                            setCheckInToDate('');
                            setCheckOutFromDate('');
                            setCheckOutToDate('');
                            fromDate.push(item.fromDate);
                            toDate.push(item.toDate);
                            disabledcheckinDates.set(fromDate);
                            disabledcheckoutDates.set(toDate);
                        }
                    }
                });
            }
            else {
                // setdisableallDates(true);
                setDisableDate(false);
            }
        })
    };
    // console.log("checkInDate",state.roomAndTaxID.get(), checkInFromDate, checkInToDate, checkOutFromDate, checkOutToDate);



    const resetState = () => {
        // console.log("hotelKeyValue", hotelKeyValue);
        state.set({
            // firstName: !(
            //     Helper.isAdminUser(userInfo) ||
            //     (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            //     (userInfo.roles && Helper.isEventStaff(userInfo))
            // )
            //     ? agentState.visible.value
            //         ? agentState.user.get() && agentState.user.get().firstName
            //         : userInfo.firstName
            //     : '',
            // lastName: !(
            //     Helper.isAdminUser(userInfo) ||
            //     (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            //     (userInfo.roles && Helper.isEventStaff(userInfo))
            // )
            //     ? agentState.visible.value
            //         ? agentState.user.get() && agentState.user.get().lastName
            //         : userInfo.lastName
            //     : '',
            firstName: '',
            lastName: '',
            isDisable: false,
            dateTimeError: false,
            dateTimeErrorMsg: '',
            hotelNameList: hotelNameList,
            hotelID: 1,
            hotelNeededId: 1,
            hotelNeeded: HotelNeeded,
            checkInDate: null,
            checkOutDate: null,
            occupant: '',
            specialRequest: '',
            roomAndTax: [],// hotelRoomTax,
            roomAndTaxID: 1,
            roomTypeID: 1,
            roomType: hotelRoomType,
            guests: [],
            occupantList: [],
            addedFor: '',
        });
    };

    // const validateFName = () => {
    //     let value = state.firstName.get().trim();
    //     if (value === '') {
    //         setFirstNameErr('Please Enter First Name');
    //         return { flag: 'false', messages: 'Please Enter  First Name' };
    //     } else {
    //         if (validator.isAlpha(value)) {
    //             setFirstNameErr('');
    //             return true;
    //         } else setFirstNameErr('Please Enter Valid First Name');
    //         return { flag: 'false', messages: 'Please Enter valid First Name' };
    //     }
    // };

    const validateFName = () => {
        let value = state.firstName.get().trim();
        if (value === '') {
            setFirstNameErr('Please Enter First Name');
            return { flag: 'false', messages: 'Please Enter  First Name' };
        } else {
            if (Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
                setFirstNameErr('');
                return true;
            } else setFirstNameErr('Please Enter Valid First Name');
            return { flag: 'false', messages: 'Please Enter valid First Name' };
        }
    };
    const validateLName = () => {
        let value = state.lastName.get().trim();
        if (value == '') {
            setLastNameErr('Please Enter Last Name');
            return { flag: 'false', messages: 'Please Enter Last Name' };
        }
        if (Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
            setLastNameErr('');
            return true;
        } else setLastNameErr('Please Enter Valid Last Name');
        return { flag: 'false', messages: 'Please Enter Valid Last Name' };
    };

    const handleAgentRoomConfirmation = (accepted) => {
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        let obj = {};
        obj.eventID = eventInfo.eventID;
        obj.moduleID = AppConstants.EVENT_MODULES.DRAFT_HOTEL;
        obj.userID = agentConnection && gAgentInfo
            ? gAgentInfo.userID
            : userInfo.userID;
        obj.IsAgentRoomRequestAccepted = accepted;
        obj.createdBy = userInfo.userID;

        ApiHelper.post(APIURLConstants.INS_UPD_HOTEL_AGENT_REQUEST, obj)
            .then((res) => {
                if (res.data) {
                    setIsAgentRequestAccepted(accepted);
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request updated successfully',
                    });
                    setShowAgentRequestConfirmDialog(false);
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while updating request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
                showAgentRequestConfirmDialog(false);
            });

    }

    function validateFields() {
        if (!isAdmin) {
            if (hotelBookingID) {
                if (roomTaxID !== state.roomAndTaxID.get()) {
                    if (
                        state.roomAndTaxID.get() === 1 &&
                        hotelCompAllotmentCount <= 0
                    ) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'All complementary room are occupied ',
                        });
                        return false;
                    }
                    if (
                        state.roomAndTaxID.get() === 2 &&
                        hotelPurchaseAllotmentCount <= 0
                    ) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'All For Purchase room are occupied ',
                        });
                        return false;
                    }
                }
            } else {
                if (
                    state.roomAndTaxID.get() === 1 &&
                    hotelCompAllotmentCount <= 0
                ) {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'All complementary room are occupied ',
                    });
                    return false;
                }
                if (
                    state.roomAndTaxID.get() === 2 &&
                    hotelPurchaseAllotmentCount <= 0
                ) {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'All For Purchase room are occupied ',
                    });
                    return false;
                }
            }
        } 
        if (state.hotelNeededId.get() === 1) {
            const fName = validateFName();
            const lName = validateLName();

            if (fName.flag === 'false' || lName.flag === 'false') {
                return false;
            }
        } 
        if (
            state.hotelNeededId.get() === 1 &&
            state.lastName.get().trim().length === 0
        ) {
            setLastNameErr('Please Enter Last Name');
            return false;
        } else {
            setLastNameErr('');
        }

        if (state.hotelNeededId.get() === 1) {
            const dateCheck = Helper.checkSameOrAfterDate(
                new Date(state.checkInDate.get()),
                new Date(state.checkOutDate.get())
            );
          
            if (
                state.checkInDate.get() === null ||
                state.checkInDate.get() === '' ||
                state.checkOutDate.get() === null ||
                state.checkOutDate.get() === ''
            ) {
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Select Check In OR Check Out Date ',
                });
                return false;
            }
            if (!dateCheck) {
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message:
                        'Check out date should be greater than or equal to Check in date',
                });

                return false;
            }
        }
        return true;
    }
    // const getSelectedParticipant = () => {
    //     const index = participantList.findIndex(
    //         (user) => user.userID == state.addedFor.get()
    //     );
    //     if (index > -1) {
    //         return setParticipant(participantList[index]);
    //     } else {
    //         return null;
    //     }
    // };

    const SETEmailNotification = (ObjRequest) => {
        let form = new FormData();
        form.append('UserID', ObjRequest.addedFor);
        form.append('EventID', ObjRequest.eventID);
        form.append('TemplateType', 'DraftHotelReservation');
        form.append('ID', ObjRequest.hotelBookID);
        form.append('ModifyBy', userInfo.userID);
        form.append('TranportType', 'DraftHotelReservation');
        form.append('ModuleID', AppConstants.EVENT_MODULES.DRAFT_HOTEL);

        ApiHelper.post(APIURLConstants.POST_EMAIL_NOTIFICATION, form)
            .then((result) => {
                // console.log(result.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getTagIDByUserID = (eventID, userID) => {
        setDisableDate(true)
        ApiHelper.get(
            APIURLConstants.GET_TAGID_BY_USERID(eventID, userID)
        ).then((res) => {
            if (res.data) {
                let data = res.data;
                let Tagsid = data[0].tagID && data[0].tagID.replace(/\s/g, '');
                if (data[0].tagID && data[0].tagID != null) {
                    getEventConfig(Tagsid)
                } else {
                    // setdisableallDates(true);
                    setDisableDate(false)
                }
            } else {
                setDisableDate(false)
            }
        })
    }

    const changeParticipant = (participant) => {
        if (participant) {
            resetState();
            const [lastName, firstName] = [...participant.name.split(', ')];
            state.firstName.set(firstName);
            state.lastName.set(lastName);
            getAllotmentCount(participant);
            fetchAgentRoomRequest(participant);
        } else {
            state.firstName.set('');
            state.lastName.set('');
            resetState();
        }
        setParticipant(participant);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // console.log("roomState.compCount",roomState,eventConfig); 
        if(Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)){
            if (participant == null) {
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Select Participant.',
                });
                return false;
            }
        } 
        const flag = validateFields();

        // console.log("selectedCard",selectedCard);
        if (flag) {
            if (
                (state.roomAndTaxID.get() == 2 || state.roomAndTaxID.get() == 3) &&
                selectedCard == null &&
                selectedCard === null
            ) {
                showSnackBar(true, 'error', 'Please enter credit card information first');
                return;
            }
            let requestObj = generateRequestObj();
            // loading.set(true);
            setShowLoading(true);
            state.isDisable.set(true);

            ApiHelper.post(APIURLConstants.POST_UPD_DRAFT_HOTEL, requestObj)
                .then(async (res) => {
                    if (res.data > 0) {
                        setShowLoading(false);
                        const editHotelState = history.location.state?.hotelState;
                        let isDraft = editHotelState ? (editHotelState.requestStatus === 'To Do' ? true : false) : true;
                        if (hotelBookingID > 0 && !isDraft) {
                            showSnackBar(true, 'success', 'Request updated successfully');
                        } else {
                            setShowLoading(false);
                            showSnackBar(true, 'success', 'Request created successfully');
                        }
                        // if (autoApprove === 1 || hotelBookingID > 0)
                        // {
                        // await SETEmailNotification(requestObj);
                        // }
                        await updateModuleState();
                        setTimeout(() => {
                            state.isDisable.set(false);
                            if (
                                Helper.isAdminUser(userInfo) ||
                                (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
                                (userInfo.roles && Helper.isEventStaff(userInfo))
                            ) {
                                props.history.push(
                                    generatePath(
                                        RouteConstants.EVENT_DRAFT_HOTEL_BOOKING_LIST,
                                        { eventID: eventInfo.eventID }
                                    )
                                );
                            } else {
                                props.history.push(
                                    generatePath(RouteConstants.EVENT_DRAFT_HOTEL, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                            }
                        }, 1000);
                        loading.set(false);
                        setShowLoading(false);
                    }
                })
                .catch((error) => {
                    loading.set(false);
                    state.isDisable.set(false);
                    setShowLoading(false);
                    console.log('Error : ', error);
                    if (error.response && error.response.status === 401) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Access denied',
                        });
                    } else {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Error while creating request',
                        });
                    }
                });
        }
    };

    const generateRequestObj = (isDraft = false) => {
        let requestObj = {};
        requestObj.hotelID = state.hotelID.get() ? state.hotelID.get() : 0;
        requestObj.hotelBookID = Number(hotelBookingID);
        requestObj.eventID = eventInfo.eventID ? eventInfo.eventID : 0;
        requestObj.roomNeeded = true; //state.hotelNeededId.get() === 1 ? true : false;
        requestObj.firstName = state.firstName.get() ? state.firstName.get() : '';
        requestObj.lastName = state.lastName.get() ? state.lastName.get() : '';
        requestObj.checkIn = state.checkInDate.get() ? dayjs(state.checkInDate.get()).format('YYYY-MM-DDT00:00') : null;
        requestObj.checkOut = state.checkOutDate.get() ? dayjs(state.checkOutDate.get()).format('YYYY-MM-DDT00:00') : null;
        requestObj.specialRequest = state.specialRequest.get() ? state.specialRequest.get() : null;

        //for DRAFT
        requestObj.hotelRoomTypeID = state.roomTypeID.get() ? state.roomTypeID.get() : null;
        requestObj.hotelRoomTaxID = state.roomAndTaxID.get() ? state.roomAndTaxID.get() : null;
        requestObj.occupantList = hotelState
            .attach(Downgraded)
            .get().occupantList;
        requestObj.modifiedDate = new Date();
        requestObj.CreatedDate = new Date();
        requestObj.createdBy = Helper.getStorage('userInfo') ? Helper.getStorage('userInfo').userID : 0;
        // this will be changed as per selected user
        requestObj.addedFor = (Helper.isEventAdmin(agentInfo) || Helper.isAdminUser(agentInfo)) ? participant
            && participant.userID : agentState.visible.value
            ? agentInfo.userID
            : participant
                ? participant.userID
                : state.addedFor.get()
                    ? state.addedFor.get()
                    : userInfo.userID;
        requestObj.moduleId = AppConstants.EVENT_MODULES.DRAFT_HOTEL;
        // requestObj.connectionID = agentState.visible.value
        //     ? agentInfo.userID
        //     : participant
        //         ? participant.userID
        //         : state.addedFor.get()
        //             ? state.addedFor.get()
        //             : userInfo.userID;
        requestObj.connectionID = (Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo)) ? participant ? participant.userID : userInfo.userID : userInfo.userID;
        // loading.set(true);
        requestObj.isDraft = isDraft;

        if (selectedCard) {
            requestObj['creditCardID'] = selectedCard.creditCardID
                ? selectedCard.creditCardID
                : 0;
            requestObj['summary'] = selectedCard.summary;
            requestObj['token'] = selectedCard.token;
            requestObj['reference'] = selectedCard.reference;
            requestObj['brand'] = selectedCard.brand;
            requestObj['store'] = selectedCard.store;
            requestObj['cardName'] = selectedCard.cardName;
            requestObj['email'] = selectedCard.email;
        }
        return requestObj;
    }

    const createCopyOfStateObject = () => {
        let hotelObj = {
            firstName: state.get().firstName ? state.get().firstName : '',
            lastName: state.get().lastName ? state.get().lastName : '',
            checkInDate: state.get().checkInDate ? Helper.FormatDate(state.get().checkInDate) : null,
            checkOutDate: state.get().checkOutDate ? Helper.FormatDate(state.get().checkOutDate) : null,
            hotelRoomTaxID: state.get().roomAndTaxID,
            hotelRoomTypeId: state.get().roomTypeID,
            specialRequest: state.get().specialRequest ? state.get().specialRequest : '',
            occupantList: state.get().occupantList,
            summary: selectedCard ? selectedCard.summary : '',
            brand: selectedCard ? selectedCard.brand : '',
            cardName: selectedCard ? selectedCard.cardName : '',
            creditCardID: selectedCard ? selectedCard.creditCardID : 0,
            email: selectedCard ? selectedCard.email : '',
        }
        return hotelObj;
    }
    const handleDisableBtn = () => {
        const editHotelState = { ...copyOfState };
        let prevData = {
            firstName: editHotelState.firstName ? editHotelState.firstName : '',
            lastName: editHotelState.lastName ? editHotelState.lastName : '',
            checkInDate: editHotelState.checkIn ? Helper.FormatDate(editHotelState.checkIn) : null,
            checkOutDate: editHotelState.checkOut ? Helper.FormatDate(editHotelState.checkOut) : null,
            hotelRoomTaxID: editHotelState.hotelRoomTaxID ? editHotelState.hotelRoomTaxID : editHotelState.roomAndTaxID,
            hotelRoomTypeId: editHotelState.hotelRoomTypeId ? editHotelState.hotelRoomTypeId : editHotelState.roomTypeID,
            specialRequest: editHotelState.specialRequest ? editHotelState.specialRequest : '',
            occupantList: editHotelState.occupantList,
            summary: editHotelState.summary ? editHotelState.summary : '',
            brand: editHotelState.brand ? editHotelState.brand : '',
            cardName: editHotelState.cardName ? editHotelState.cardName : '',
            creditCardID: editHotelState.creditCardID ? editHotelState.creditCardID : 0,
        };
        let currentData = createCopyOfStateObject();
        // console.log('prevData', prevData);
        // console.log('currentData', currentData)
        //history.location.state.hotelState;
        // console.log('editHotelState : ', editHotelState);
        if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
            setDisableBtn(true);
        } else {
            setDisableBtn(false);
        }
    };

    const showSnackBar = (open, variant, message) => {
        setSnackBarProps({
            openSnack: open,
            variant: variant,
            message: message
        });
    }

    const addCard = () => {
        const flag = validateFields();

        if (flag == true) {
            if (userID) {
                const passUserID = participant ? participant.userID : userID;
                const connectionID = agentInfo ? agentInfo.userID : passUserID;

                ApiHelper.get(
                    APIURLConstants.GET_PREV_DETAILS(connectionID, passUserID)
                )
                    .then((res) => {
                        if (res.data) {
                            setPrevCreditCards(res.data);
                            setShowCreditCard(true);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                setShowCreditCard(true);
            }
        }
        // setShowCreditCard(true);
    };
    const storeCardInfo = (obj) => {
        // console.log("cardSummary: ", cardSummary);
        // console.log("cardToken : ", cardToken);
        setSelectedCard(obj);
        setTimeout(() => {
            handleDisableBtn();
        }, 100);
    };
    // console.log('participantList', participantList);

    const renderWaitListNote = () => {
        return (
            <Grid item lg={12} md={12} sm={12} xs={12}>
                {
                    state.roomAndTaxID.get() && state.roomAndTaxID.get() == 3 ? (
                        <Typography
                            sx={{
                                color: 'red'
                            }}
                            variant='body2'
                        >
                            This hotel room request has been put on the waiting list. Please note these requests are subject to availability and are not to be considered confirmed unless the NBA approves this request.
                        </Typography>
                    ) : null
                }
            </Grid>
        )
    }

    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission != FULL_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <Box
                    className="contentBox"
                    style={{ paddingLeft: '24px', paddingRight: '24px' }}>
                    <Box
                        sx={{
                            width: '100%',
                            '& .MuiFormControl-root': { width: '100%' },
                        }}>
                        <Box
                            component="form"
                            sx={{
                                width: '100%',
                                '& .MuiFormControl-root': { width: '100%' },
                            }}
                            onSubmit={handleSubmit}>
                            <Box>
                                <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                                    AppConstants.EVENT_MODULES.COMBINE_HOTEL)} />
                            </Box>

                            {participantList && (
                                <Box
                                    sx={{
                                        width: ' 30%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 0.3,
                                        justifyContent: 'center',
                                        mx: 'auto',

                                        // '& .MuiFormControl-root': { width: '100%' },
                                    }}>
                                    <ParticipantAutoList
                                        // participant={
                                        //     state.addedFor.get()
                                        //         ? participantList[
                                        //               participantList.findIndex(
                                        //                   (user) =>
                                        //                       user.userID ==
                                        //                       state.addedFor.get()
                                        //               )
                                        //           ]
                                        //         : participant
                                        // }
                                        disableParticipant={
                                            params.hotelBookingID ? true : false
                                        }
                                        participant={participant}
                                        setParticipant={changeParticipant}
                                        participantList={participantList}
                                        modPermission={modPermission}
                                    />
                                </Box>
                            )}
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                    padding: 0,
                                    flex: 1,
                                    marginTop: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flex: 0.5,
                                        alignItems: 'center',
                                        padding: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            flex: 1,
                                            alignItems: 'center',
                                        }}>

                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flex: 0.5,
                                        alignItems: 'center',
                                        marginTop: { xs: 2, md: 0 },
                                        padding: 1,
                                    }}>
                                    {!isEmpty(hotelKeyValue) ? (
                                        hotelKeyValue.RoomNeeded === 1 ? (
                                            <FormControl
                                                fullWidth={false}
                                                size="small">
                                                <InputLabel id="demo-simple-select-label">
                                                    Hotel Room Needed?
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={state.hotelNeededId.get()}
                                                    label="Hotel Room Needed?"
                                                    onChange={
                                                        handleChangeHotelNeeded
                                                    }>
                                                    {state.hotelNeeded.get() &&
                                                        state.hotelNeeded
                                                            .get(Downgraded)
                                                            .map((option) => (
                                                                <MenuItem
                                                                    key={
                                                                        option.value
                                                                    }
                                                                    value={
                                                                        option.value
                                                                    }>
                                                                    {
                                                                        option.label
                                                                    }
                                                                </MenuItem>
                                                            ))}
                                                </Select>
                                            </FormControl>
                                        ) : null
                                    ) : null}

                                </Box>
                            </Box>
                            {/* 
                        {state.hotelNeededId.get() &&
                            state.hotelNeededId.get() === 0 ? ( */}
                            <>
                                <Grid
                                    container
                                    rowSpacing={2}
                                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                    sx={{
                                        padding: 0,
                                        marginTop: 1,
                                    }}>
                                    <Grid item lg={6} md={6} xs={12}>
                                        <TextField
                                            required={
                                                state.hotelNeededId.get() === 1
                                                    ? true
                                                    : false
                                            }
                                            size="small"
                                            id="outlined-required"
                                            label="First Name"
                                            autoComplete="off"
                                            onBlur={validateFName}
                                            value={state.firstName.get()}
                                            onChange={(event) => {
                                                state.firstName.set(
                                                    event.target.value
                                                ),
                                                    setFirstNameErr('');
                                                handleDisableBtn();
                                            }}
                                            // onBlur={validateFirstName}
                                            error={
                                                firstNameErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                            helperText={
                                                firstNameErr.length > 0
                                                    ? firstNameErr
                                                    : ''
                                            }
                                            inputProps={{ maxLength: 50 }}
                                        />
                                    </Grid>
                                    <Grid item lg={6} md={6} xs={12}>
                                        <TextField
                                            required={
                                                state.hotelNeededId.get() === 1
                                                    ? true
                                                    : false
                                            }
                                            size="small"
                                            id="outlined-required"
                                            label="Last Name"
                                            autoComplete="off"
                                            value={state.lastName.get()}
                                            onChange={(event) => {
                                                state.lastName.set(
                                                    event.target.value
                                                ),
                                                    setLastNameErr('');
                                                handleDisableBtn();
                                            }}
                                            onBlur={validateLName}
                                            error={
                                                lastNameErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                            helperText={
                                                lastNameErr.length > 0
                                                    ? lastNameErr
                                                    : ''
                                            }
                                            inputProps={{ maxLength: 50 }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid
                                    container
                                    rowSpacing={2}
                                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                    sx={{
                                        padding: 0,
                                        marginTop: 1,
                                    }}>
                                    <Grid item lg={6} md={6} xs={12} sx={{}}>
                                        <MUIDatePicker
                                            label='Check In'
                                            value={state.checkInDate
                                                .attach(Downgraded)
                                                .get()}
                                            error={state.dateTimeErrorMsg.get()}
                                            disablePast={true}
                                            setValue={handleCheckInDateTime}
                                            minDate={checkInFromDate && dayjs(checkInFromDate)}
                                            maxDate={checkInToDate && dayjs(checkInToDate)}
                                            disabledDates={disabledcheckinDates.get() !== undefined ? disabledcheckinDates.get() : []}
                                            disabled={disableDate}
                                        />

                                    </Grid>
                                    <Grid item lg={6} md={6} xs={12} sx={{}}>
                                        <MUIDatePicker
                                            label='Check Out'
                                            value={state.checkOutDate
                                                .attach(Downgraded)
                                                .get()}
                                            disablePast={true}
                                            error={state.dateTimeErrorMsg.get()}
                                            setValue={handleCheckOutDateTime}
                                            minDate={checkOutFromDate && dayjs(checkOutFromDate)}
                                            maxDate={checkOutToDate && dayjs(checkOutToDate)}
                                            disabledDates={disabledcheckoutDates.get() !== undefined ? disabledcheckoutDates.get() : []}
                                            disabled={disableDate}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    rowSpacing={2}
                                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                    sx={{
                                        padding: 0,
                                        marginTop: 1,
                                    }}>
                                    <Grid item lg={6} md={6} xs={12}>
                                        {state.roomAndTax.get() && (
                                            <FormControl
                                                fullWidth={false}
                                                size="small">
                                                <InputLabel id="demo-simple-select-label">
                                                    Room Type
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={state.roomAndTaxID.get()}
                                                    label="Hotel Room Needed?"
                                                    onChange={
                                                        handleChangeRoomTax
                                                    }>
                                                    {state.roomAndTax.get() &&
                                                        state.roomAndTax
                                                            .get(Downgraded)
                                                            .map((option) => (
                                                                <MenuItem
                                                                    key={
                                                                        option.value
                                                                    }
                                                                    value={
                                                                        option.value
                                                                    }>
                                                                    {
                                                                        option.label
                                                                    }
                                                                </MenuItem>
                                                            ))}
                                                </Select>
                                            </FormControl>
                                        )}
                                    </Grid>
                                    <>
                                        {
                                            (isMobile && state.roomAndTaxID.get() && state.roomAndTaxID.get() == 3) &&
                                            renderWaitListNote()
                                        }
                                    </>
                                    <Grid item lg={6} md={6} xs={12}>
                                        {state.roomType.get() && (
                                            <FormControl
                                                fullWidth={false}
                                                size="small">
                                                <InputLabel id="demo-simple-select-label">
                                                    Bed
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={state.roomTypeID.get()}
                                                    label="Select Hotel"
                                                    onChange={
                                                        handleChangeRoomType
                                                    }>
                                                    {state.roomType.get() &&
                                                        state.roomType
                                                            .get(Downgraded)
                                                            .map((option) => (
                                                                <MenuItem
                                                                    key={
                                                                        option.value
                                                                    }
                                                                    value={
                                                                        option.value
                                                                    }>
                                                                    {
                                                                        option.label
                                                                    }
                                                                </MenuItem>
                                                            ))}
                                                </Select>
                                            </FormControl>
                                        )}
                                    </Grid>
                                    <>
                                        {
                                            (!isMobile && state.roomAndTaxID.get() && state.roomAndTaxID.get() == 3) &&
                                            renderWaitListNote()
                                        }
                                    </>
                                </Grid>
                                <Grid
                                    container
                                    rowSpacing={2}
                                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                    sx={{
                                        padding: 0,
                                        marginTop: 1,
                                        pb: 2,
                                    }}>
                                    <Grid item lg={6} md={6} xs={12}>
                                        <TextField
                                            size="small"
                                            id="outlined-required"
                                            label="Special Request"
                                            value={state.specialRequest.get()}
                                            onChange={(event) => {
                                                state.specialRequest.set(
                                                    event.target.value
                                                );
                                                handleDisableBtn();
                                            }}
                                            inputProps={{
                                                maxLength: 260,
                                            }}
                                            multiline={true}
                                            minRows={3}
                                            maxRows={10}
                                        />
                                    </Grid>
                                    <Grid item lg={6} md={6} xs={12}>
                                        {state.roomAndTaxID.get() == 2 || state.roomAndTaxID.get() == 3 ? (
                                            <>
                                                <Button
                                                    variant="outlined"
                                                    onClick={addCard}>
                                                    {hotelBookingID > 0
                                                        ? 'Edit Card Details'
                                                        : 'Add Card Details'}
                                                </Button>
                                                {selectedCard ? (
                                                    <Box
                                                        component="div"
                                                        sx={{
                                                            pl: 1,
                                                            pr: 1,
                                                            pt: 0.5,
                                                            pb: 0.5,
                                                        }}>
                                                        {/* <img src={`${logoURL}${'visa'}.svg`} width='24' height={16} style={{border: '1px solid #ccc', borderRadius: 4, marginRight: '8px'}} />{`****-${'4000'} - ${'Amit'}`} */}
                                                        <img
                                                            src={`${logoURL}${selectedCard.brand}.svg`}
                                                            width="24"
                                                            height={16}
                                                            style={{
                                                                border: '1px solid #ccc',
                                                                borderRadius: 4,
                                                                marginRight:
                                                                    '8px',
                                                            }}
                                                        />
                                                        {`****-${selectedCard.summary} - ${selectedCard.cardName}`}
                                                    </Box>
                                                ) : null}
                                            </>
                                        ) : null}

                                    </Grid>
                                </Grid>
                            </>
                            {showCreditCard ? (
                                <AddCreditCard
                                    showCreditCard={showCreditCard}
                                    hideCreditCard={setShowCreditCard}
                                    storeCardInfo={storeCardInfo}
                                    userID={
                                        participant
                                            ? participant.userID
                                            : userID
                                    }
                                    eventID={eventID}
                                    connection={
                                        agentInfo
                                            ? agentInfo.userID
                                            : participant
                                                ? participant.userID
                                                : userID
                                    }
                                    prevCreditCards={prevCreditCards}
                                    setSnackBarProps={setSnackBarProps}
                                    setShowCardValidationMessage={setShowCardValidationMessage}
                                // existingCard={existingCard}
                                />
                            ) : null}
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    // alignItems: 'center',
                                    justifyContent: 'space-between',
                                    backgroundColor: '#f8f8f8',
                                    flex: 1,
                                    marginBottom: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={{
                                            xs: '12px',
                                            md: '16px',
                                        }}
                                        fontWeight={500}
                                        paddingLeft={1}
                                        paddingTop={1}
                                        color={'primary'}
                                        pb={1}>
                                        Other Occupant
                                    </Typography>
                                </Box>
                                <Box sx={{ padding: 1 }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleOccupantCounter}
                                        color="primary"
                                        disabled={state.isDisable.get()}>
                                        Add Other Occupant
                                    </Button>
                                </Box>
                            </Box>

                            {state.occupantList.attach(Downgraded).get()
                                .length > 0 &&
                                state.occupantList
                                    .attach(Downgraded)
                                    .get()
                                    .map((field, idx) => {
                                        return (
                                            <Box
                                                key={idx}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent:
                                                        'space-between',
                                                    flex: 1,
                                                    marginTop: 1,
                                                    backgroundColor: '#f8f8f8',
                                                }}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            color={'primary'}
                                                            pb={1}>
                                                            First Name
                                                        </Typography>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {field.firstName}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            color={'primary'}
                                                            pb={1}>
                                                            Last Name
                                                        </Typography>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {field.lastName}
                                                        </Typography>
                                                    </Box>

                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                            alignItems:
                                                                'center',
                                                            justifyContent:
                                                                'flex-end',
                                                        }}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                flex: 0.05,
                                                            }}>
                                                            <Box
                                                                component="img"
                                                                className={
                                                                    classes.sedanBlack
                                                                }
                                                                alt="logo."
                                                                src={IconPencil}
                                                                onClick={() =>
                                                                    handleOccupantEditData(
                                                                        field.firstName,
                                                                        field.lastName,
                                                                        field.relation,
                                                                        idx
                                                                    )
                                                                }
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                flex: 0.05,
                                                            }}>
                                                            <Box
                                                                component="img"
                                                                className={
                                                                    classes.sedanBlack
                                                                }
                                                                alt="logo."
                                                                src={trash}
                                                                onClick={() =>
                                                                    handleRemoveOccupant(
                                                                        idx
                                                                    )
                                                                }
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        );
                                    })}
                            {/* <Divider sx={{ py: 1 }} component="div" /> */}

                            {!isEmpty(hotelKeyValue) ? (
                                hotelKeyValue.ShowGuestroom === 1 ? (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            // alignItems: 'center',
                                            justifyContent: 'space-between',
                                            backgroundColor: '#f8f8f8',
                                            flex: 1,
                                            marginBottom: 1,
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                            }}>
                                            <Typography
                                                variant="h4"
                                                fontSize={{
                                                    xs: '12px',
                                                    md: '16px',
                                                }}
                                                fontWeight={500}
                                                paddingLeft={1}
                                                paddingTop={1}
                                                color={'primary'}
                                                pb={1}>
                                                Do you want to add guest room?
                                            </Typography>
                                        </Box>
                                        <Box sx={{ padding: 1 }}>
                                            <Button
                                                variant="contained"
                                                onClick={handleGuestCounter}
                                                color="primary">
                                                + Add Guest Room
                                            </Button>
                                        </Box>
                                    </Box>
                                ) : null
                            ) : null}

                            {!isEmpty(hotelKeyValue)
                                ? hotelKeyValue.ShowGuestroom === 1
                                    ? state.guests.attach(Downgraded).get()
                                        .length > 0 &&
                                    state.guests
                                        .attach(Downgraded)
                                        .get()
                                        .map((field, idx) => {
                                            return (
                                                <Box
                                                    key={idx}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        flex: 1,
                                                        marginTop: 1,
                                                        backgroundColor:
                                                            '#f8f8f8',
                                                    }}>
                                                    <Box
                                                        flex={0.3}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            color={'primary'}
                                                            pb={1}>
                                                            First Name
                                                        </Typography>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {
                                                                field.guestFirstName
                                                            }
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        flex={0.3}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            color={'primary'}
                                                            pb={1}>
                                                            Last Name
                                                        </Typography>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {
                                                                field.guestLastName
                                                            }
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        flex={0.4}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            color={'primary'}
                                                            pb={1}>
                                                            Room Type
                                                        </Typography>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {field.roomType}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        flex={0.5}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            color={'primary'}
                                                            pb={1}>
                                                            Room And Tax
                                                        </Typography>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {field.roomAndTax}
                                                        </Typography>
                                                    </Box>

                                                    <Box
                                                        flex={0.5}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            color={'primary'}
                                                            pb={1}>
                                                            Check In
                                                        </Typography>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {`${Helper.FormatYearDate(
                                                                field.guestCheckIn
                                                            )} ${Helper.FormatTime24(
                                                                field.guestCheckIn
                                                            )}`}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        flex={0.5}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            color={'primary'}
                                                            pb={1}>
                                                            Check Out
                                                        </Typography>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {`${Helper.FormatYearDate(
                                                                field.guestCheckOut
                                                            )} ${Helper.FormatTime24(
                                                                field.guestCheckOut
                                                            )}`}
                                                        </Typography>
                                                    </Box>

                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                            justifyContent:
                                                                'flex-end',
                                                            // alignItems: 'center',
                                                        }}>
                                                        <Box
                                                            sx={{
                                                                display:
                                                                    'flex',
                                                                alignItems:
                                                                    'center',
                                                                flex: 0.05,
                                                            }}>
                                                            <Box
                                                                component="img"
                                                                className={
                                                                    classes.sedanBlack
                                                                }
                                                                alt="logo."
                                                                src={
                                                                    IconPencil
                                                                }
                                                                onClick={() =>
                                                                    handleEditData(
                                                                        field.guestFirstName,
                                                                        field.guestLastName,
                                                                        field.guestCheckIn,
                                                                        field.guestCheckOut,
                                                                        field.roomTypeID,
                                                                        field.roomAndTaxID,
                                                                        field.roomType,
                                                                        field.roomAndTax,
                                                                        idx
                                                                    )
                                                                }
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display:
                                                                    'flex',
                                                                alignItems:
                                                                    'center',
                                                                flex: 0.05,
                                                            }}>
                                                            <Box
                                                                component="img"
                                                                className={
                                                                    classes.sedanBlack
                                                                }
                                                                alt="logo."
                                                                src={trash}
                                                                onClick={() =>
                                                                    handleRemove(
                                                                        idx
                                                                    )
                                                                }
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            );
                                        })
                                    : null
                                : null}

                            <Divider component="div" />

                            {/* {renderIsDisable()} */}

                            <ButtonContainer
                                handleCancel={handleBtnCancel}
                                buttonText={
                                    hotelBookingID > 0 ? showSaveAsDraftBtn ? 'Create' : (history.location.state && history.location.state?.hotelState && history.location.state?.hotelState.requestStatus.toLowerCase() == "pending") ? 'Update & Submit' : 'Update' : 'Create'
                                }
                                disableButton={state.isDisable.get()}
                                showLoading={showLoading}
                                loading={showLoading}
                                disableUpdateButton={disableBtn}
                            />

                            {openDialog.get() &&
                                state.roomType.get() &&
                                state.roomAndTax.get() && (
                                    <AddGuest
                                        open={openDialog.get()}
                                        title={
                                            stateObj.get()
                                                ? 'Update Guest'
                                                : 'Add Guest'
                                        }
                                        handleClose={handleClose}
                                        handleAction={handleAction}
                                        data={stateObj.get()}
                                        roomTaxData={state.roomAndTax
                                            .attach(Downgraded)
                                            .get()}
                                        roomTypeData={state.roomType
                                            .attach(Downgraded)
                                            .get()}
                                    />
                                )}

                            {openOccupantDialog.get() && (
                                <AddOccupant
                                    open={openOccupantDialog.get()}
                                    title={
                                        stateOccupantObj.get()
                                            ? 'Update Occupant'
                                            : 'Add Occupant'
                                    }
                                    handleClose={handleOccupantClose}
                                    handleAction={handleOccupantAction}
                                    data={stateOccupantObj.get()}
                                />
                            )}
                            {snackBarProps.openSnack && (
                                <CustomizedSnackbars
                                    {...snackBarProps}
                                    onClose={() =>
                                        setSnackBarProps({
                                            ...snackBarProps,
                                            openSnack: false,
                                        })
                                    }></CustomizedSnackbars>
                            )}

                            {
                                openBackdrop &&
                                <Backdrop
                                    sx={{
                                        color: '#fff',
                                        zIndex: (theme) => theme.zIndex.drawer + 150,
                                    }}
                                    open={openBackdrop}
                                >
                                    <CircularProgress color="inherit" />
                                </Backdrop>
                            }

                            {
                                <ConfirmationDialog
                                    open={showAgentRequestConfirmDialog}
                                    message={AppConstants.HOTEL_AGENT_ROOM_CONFIRM_TEXT}
                                    OkButtonText={'No'}
                                    handleCnfClick={() =>
                                        handleAgentRoomConfirmation(false)
                                    }
                                    CancelButtonText={'Yes'}
                                    onCancelClick={() => {
                                        handleAgentRoomConfirmation(true)
                                    }}></ConfirmationDialog>
                            }
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};
export default {
    routeProps: {
        path: [
            RouteConstants.CREATE_DRAFT_EVENT_HOTEL,
            RouteConstants.EDIT_DRAFT_HOTEL_EVENT,
        ],
        component: CreateDraftHotel,
    },
    name: 'CreateDraftHotel',
};
